import _ from "lodash";
import React from "react";
import { useSelector } from "react-redux";
import { findMostRecentMetadata, getAbsoluteTimestamp } from "./util/PlaylistUtils";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faInfoCircle } from "@fortawesome/pro-solid-svg-icons";
import { Tooltip } from "antd";

const timestampSelector = (state) => {
    const routeID = state.playlist.data.routeID;
    const isVideo = state.playlist.position.isVideo;
    const sourceIndex = state.playlist.position.sourceIndex;
    const playlist = isVideo ? _.get(state.playlist.data, ["video", sourceIndex], []) : state.playlist.data.image;
    const index = state.playlist.position.currentIndex;
    const offset = state.playlist.position.currentTimeOffset || 0;
    return getAbsoluteTimestamp(routeID, playlist, index, isVideo, offset);
};

const humidityAndTempSelector = (state) => {
    return _.get(state.routeMetadata, ["EZO_HUM_STATUS", state.playlist.data.routeID], []);
};

const videolessTimestampSelector = (state) => {
    if (_.get(state, ["playlist", "data", "video", "length"], 0)) {
        return null;
    }
    const currentIndex = state.playlist.position.currentIndex;
    const railImages = state.railInspection.railInspectionImages.data;

    let timestamp = 0;
    if (railImages[currentIndex]) {
        const currentImage = railImages[currentIndex];
        timestamp = currentImage.timestamp;
    }
    return timestamp;
};

export default function CoronaDetectionsExtraData({ detection }) {
    const timestamp = useSelector(timestampSelector);
    const humidityAndTempMetadata = useSelector(humidityAndTempSelector);
    const videolessTimestamp = useSelector(videolessTimestampSelector);

    let timestampSeconds = videolessTimestamp ? videolessTimestamp / 1000 : timestamp;
    const humidityAndTempInfo = findMostRecentMetadata(humidityAndTempMetadata, timestampSeconds);

    let temperature = "Unknown";
    let humidity = "Unknown";

    if (!_.isNil(humidityAndTempInfo?.data.temperature)) {
        temperature = `${Number(humidityAndTempInfo.data.temperature).toFixed(2)}°C`;
    }

    if (!_.isNil(humidityAndTempInfo?.data.humidity)) {
        humidity = `${Number(humidityAndTempInfo.data.humidity).toFixed(2)}%`;
    }

    return (
        <div className="DetectionsExtraData">
            <div>
                <span className="title">Detection Data</span>
                <dl>
                    <dt className="muted">
                        Match count{" "}
                        <Tooltip
                            placement="bottom"
                            title="The number of frames in which this object was detected and successfully linked together into a single tracked observation. Higher counts generally mean a more persistent detection.">
                            <FontAwesomeIcon icon={faInfoCircle} />
                        </Tooltip>
                    </dt>
                    <dd>{_.get(detection, ["match_count"], "Unknown")}</dd>
                </dl>
            </div>

            <div>
                <span className="title">Environmental Data</span>
                <dl>
                    <dt className="muted">Temperature</dt>
                    <dd>{temperature}</dd>
                    <dt className="muted">Humidity</dt>
                    <dd>{humidity}</dd>
                </dl>
            </div>
        </div>
    );
}
